
import { OmnisoftLoginRequestData } from './omnisoft-login-request-data';

export class OmnisoftLoginRequest {
  requestData: OmnisoftLoginRequestData;
}
